import { VerificationStep } from '../types';

export const verificationSteps: VerificationStep[] = [
  { key: 'verify', title: 'Verify' },
  { key: 'deposit', title: 'Deposit' },
  { key: 'trade', title: 'Trade' },
];
